import { Tooltip } from '@mui/material'
import cn from 'classnames'
import moment from 'moment'
import React from 'react'
import config from '../../config.json'
import Link from '../common/util/input/Link'
import { get, post } from './Api'

export const getEndpoint = (search, def = 'assets') => {
    let endpoint = def

    if (
        [
            'assets',
            'duplicates',
            'highest_duplicates',
            'packs',
            'inventory',
            'pfps',
            'bulk_multi_sell',
            'lowest_mints',
            'highest_mints',
            'bulk_transfer_lowest_mints',
            'bulk_transfer',
            'bulk_distribute',
            'bulk_transfer_duplicates',
            'bulk_stake',
            'bulk_unstake',
            'bulk_sell',
            'bulk_burn',
            'bulk_sell_duplicates',
            'bulk_sell_duplicates',
            'bulk_bundle',
            'bulk_bundle_lowest_mints',
            'bulk_bundle_highest_mints',
            'bulk_bundle_highest_duplicates',
            'bulk_sell_highest_duplicates',
            'bulk_multi_sell',
        ].includes(search)
    ) {
        endpoint = 'assets'
    } else if (['trades', 'sells', 'buys', 'sales'].includes(search)) {
        endpoint = 'sales'
    } else if (search === 'templates') {
        endpoint = 'templates'
    } else if (
        [
            'bulk_buy',
            'missing',
            'cheapest',
            'cheapest_missing',
            'listings',
            'bulk_cancel',
            'bulk_edit',
        ].includes(search)
    ) {
        endpoint = 'listings'
    } else if (
        ['auctions', 'my_auctions', 'my_exp_auctions'].includes(search)
    ) {
        endpoint = 'auctions'
    } else if (
        [
            'buyoffers',
            'my_buyoffers',
            'buyoffers_owned',
            'best_buyoffers',
            'best_buyoffers_owned',
        ].includes(search)
    ) {
        endpoint = 'buyoffers'
    }

    return endpoint
}

export const getOwnerTerm = (endpoint, def = 'owner') => {
    switch (endpoint) {
        case 'templates':
        case 'assets':
            return 'owner'
        case 'listings':
        case 'auctions':
        case 'sales':
        case 'auction':
        case 'sells':
            return 'seller'
        case 'buys':
        case 'buyoffers':
            return 'buyer'
    }

    return def
}

export const sleep = (ms) => {
    return new Promise((resolve) => setTimeout(resolve, ms))
}

export const tokenSortFunc = (a, b) => {
    if (a.label === 'WAX' && b.label !== 'WAX') {
        return -1
    } else if (b.label === 'WAX' && a.label !== 'WAX') {
        return 1
    } else if (a.label === 'USD' && b.label !== 'WAX' && b.label !== 'USD') {
        return -1
    } else if (b.label === 'USD' && a.label !== 'WAX' && a.label !== 'USD') {
        return 1
    } else if (
        a.label === 'HONEY' &&
        b.label !== 'WAX' &&
        b.label !== 'USD' &&
        b.label !== 'HONEY'
    ) {
        return -1
    } else if (
        b.label === 'HONEY' &&
        a.label !== 'WAX' &&
        a.label !== 'USD' &&
        a.label !== 'HONEY'
    ) {
        return 1
    } else if (
        a.label === 'WUF' &&
        b.label !== 'WAX' &&
        b.label !== 'USD' &&
        b.label !== 'HONEY' &&
        b.label !== 'WUF'
    ) {
        return -1
    } else if (
        b.label === 'WUF' &&
        a.label !== 'WAX' &&
        a.label !== 'USD' &&
        a.label !== 'HONEY' &&
        a.label !== 'WUF'
    ) {
        return 1
    } else if (a.label < b.label) {
        return -1
    } else if (a.label > b.label) {
        return 1
    }

    return 0
}

export const parseAtomicImmutableData = (atomicData) => {
    if (!atomicData) return atomicData
    const idata = atomicData.immutable_data
    const template_idata = atomicData.template
        ? atomicData.template.immutable_data
        : {}

    const data = {}

    for (const format of atomicData.schema.format) {
        if (Object.keys(idata).includes(format['name'])) {
            data[format['name']] = idata[format['name']]
        } else if (Object.keys(template_idata).includes(format['name'])) {
            data[format['name']] = template_idata[format['name']]
        }
    }

    return data
}

export const parseAtomicMutuableData = (atomicData) => {
    return atomicData.mutable_data &&
        Object.keys(atomicData.mutable_data).length > 0
        ? atomicData.mutable_data
        : null
}

export const setQueryStringWithoutPageReload = (qsValue) => {
    const newurl =
        window.location.protocol +
        '//' +
        window.location.host +
        window.location.pathname +
        '?' +
        qsValue
    const newPath = window.location.pathname + '?' + qsValue

    const oldState = window.history.state
    oldState.path = newPath
    oldState.url = newurl

    window.history.replaceState(oldState, '', newPath)
}

export const setQueryStringWithoutPageReloadPush = (qsValue) => {
    const newurl =
        window.location.protocol +
        '//' +
        window.location.host +
        window.location.pathname +
        (qsValue && qsValue.length > 0 ? '?' : '') +
        qsValue
    const newPath =
        window.location.pathname +
        (qsValue && qsValue.length > 0 ? '?' : '') +
        qsValue

    let oldState = window.history.state

    if (!oldState) {
        oldState = {
            path: newPath,
            url: newurl,
            as: newPath,
        }
    } else {
        oldState.path = newPath
        oldState.url = newurl
        oldState.as = newPath
    }

    window.history.pushState(oldState, '', newPath)
}

export const getOwnerLink = (owner) => {
    return owner ? (
        <Link href={`/user/${owner}`}>
            <div className="cursor-pointer text-primary hover:underline">
                {owner}
            </div>
        </Link>
    ) : null
}

export const getAuthorLink = (author) => {
    return (
        <Link href={`/collection/${author}`}>
            <div className="cursor-pointer">{author}</div>
        </Link>
    )
}

export const createCollectionList = (data, search = '', def = '') => {
    const collections = []

    if (def) {
        ;(data['collections'] ? data['collections'] : data)
            .filter((collection) => collection === def)
            .forEach((element) => {
                if (!collections.find((a) => a.value === element))
                    if (
                        !search ||
                        element.toLowerCase().includes(search.toLowerCase()) ||
                        (data['names'][element] &&
                            data['names'][element]
                                .toLowerCase()
                                .includes(search.toLowerCase()))
                    )
                        collections.push({
                            value: element,
                            title: data['names'][element]
                                ? data['names'][element]
                                : element,
                            label: element,
                            image:
                                data['images'] && data['images'][element]
                                    ? data['images'][element]
                                    : '',
                        })
            })
    }

    ;(data['collections'] ? data['collections'] : data)
        .filter((collection) => data['verified'][collection])
        .forEach((element) => {
            if (!collections.find((a) => a.value === element))
                if (
                    !search ||
                    element.toLowerCase().includes(search.toLowerCase()) ||
                    (data['names'][element] &&
                        data['names'][element]
                            .toLowerCase()
                            .includes(search.toLowerCase()))
                )
                    collections.push({
                        value: element,
                        title: data['names'][element]
                            ? data['names'][element]
                            : element,
                        label: element,
                        image:
                            data['images'] && data['images'][element]
                                ? data['images'][element]
                                : '',
                    })
        })
    ;(data['collections'] ? data['collections'] : data)
        .filter((collection) => !data['verified'][collection])
        .forEach((element) => {
            if (!collections.find((a) => a.value === element))
                if (
                    !search ||
                    element.toLowerCase().includes(search.toLowerCase()) ||
                    (data['names'][element] &&
                        data['names'][element]
                            .toLowerCase()
                            .includes(search.toLowerCase()))
                )
                    collections.push({
                        value: element,
                        title: data['names'][element]
                            ? data['names'][element]
                            : element,
                        label: element,
                        image:
                            data['images'] && data['images'][element]
                                ? data['images'][element]
                                : '',
                    })
        })

    return collections
}

export const getImage = (author) => {
    if (author && author !== '*')
        return 'https://ipfs.hivebp.io/hive/author/' + author

    return 'https://nfthive.io/nfthive-logo.png'
}

export const getImageData = (images, imageFormats, assetData, format) => {
    if (format && assetData) {
        const formatDict = {}
        for (let a of format) {
            formatDict[a['name']] = a['type']
        }
        Object.keys(formatDict).map((key) => {
            if (
                formatDict[key] &&
                (formatDict[key] === 'image' || formatDict[key] === 'video') &&
                assetData[key]
            ) {
                const image = assetData[key].includes('http')
                    ? assetData[key]
                    : `${config.ipfs}${assetData[key]}`
                if (!images.includes(image) && !image.includes('video:')) {
                    images.push(image)
                    imageFormats.push(formatDict[key])
                }
            }
        })
    }
}

export const createSchemas = (
    categories,
    includeDefault = true,
    schemaOptions = null,
) => {
    const categoriesOptions = []
    const addedCategories = []

    if (!categories || !categories.length) return null

    if (includeDefault) categoriesOptions.push({ value: '', label: 'All' })

    categories.forEach((element) => {
        if (
            element['schema'] &&
            (!schemaOptions || schemaOptions.includes(element['schema']))
        ) {
            if (!addedCategories.includes(element['schema'])) {
                categoriesOptions.push({
                    value: element['schema'],
                    label: element['schema'],
                })
                addedCategories.push(element['schema'])
            }
        }
    })

    return categoriesOptions
}

export const createCategories = (t) => {
    return [
        {
            value: 64,
            label: t('collection_category.1'),
        },
        {
            value: 65,
            label: t('collection_category.2'),
        },
        {
            value: 69,
            label: t('collection_category.3'),
        },
        {
            value: 66,
            label: t('collection_category.4'),
        },
        {
            value: 67,
            label: t('collection_category.5'),
        },
        {
            value: 68,
            label: t('collection_category.6'),
        },
    ]
}

export const createTemplates = (categories, includeDefault = true) => {
    const categoriesOptions = []
    const addedTemplates = []

    if (!categories || !categories.length) return null

    if (includeDefault) categoriesOptions.push({ value: '', label: 'All' })

    categories.forEach((element) => {
        if (element['templateId']) {
            if (!addedTemplates.includes(element['templateId'])) {
                categoriesOptions.push({
                    value: element['templateId'],
                    label: element['templateId'],
                })
                addedTemplates.push(element['templateId'])
            }
        }
    })

    return categoriesOptions
}

export const createRarities = (categories, includeDefault = true) => {
    const categoriesOptions = []
    const addedRarities = []

    if (!categories || !categories.length) return null

    if (includeDefault) categoriesOptions.push({ value: '', label: 'All' })

    categories.forEach((element) => {
        if (element['rarity']) {
            if (!addedRarities.includes(element['rarity'])) {
                categoriesOptions.push({
                    value: element['rarity'],
                    label: element['rarity'],
                })
                addedRarities.push(element['rarity'])
            }
        }
    })

    return categoriesOptions
}

export const getUsdWax = async (state) => {
    const body = {
        code: 'delphioracle',
        index_position: 'primary',
        json: 'true',
        key_type: 'i64',
        limit: 1,
        lower_bound: '',
        upper_bound: '',
        reverse: 'true',
        scope: 'waxpusd',
        show_payer: 'false',
        table: 'datapoints',
        table_key: '',
    }

    const url =
        process.env.NEXT_PUBLIC_TESTNET === 'TRUE'
            ? config.testapi + '/v1/chain/get_table_rows'
            : state.api + '/v1/chain/get_table_rows'
    const res2 = await post(url, body)

    if (res2 && res2.status === 200 && res2.data && res2.data.rows) {
        const median = parseFloat(res2.data.rows[0]['median'])
        return { usd_wax: median / 10000.0 }
    } else {
        return get('usd-wax', 'wax-api')
    }
}

export const formatDiffFloor = (diff, market, target) => {
    return (
        <Tooltip
            title={
                'waxbuyoffers' !== market
                    ? diff > 0
                        ? `Price is ${formatWAX(diff)} above ${target}`
                        : `Price at ${target}`
                    : diff > 0
                    ? `Offer is ${formatWAX(diff)} above ${target}`
                    : `Offer is at ${target}`
            }
        >
            <div
                className={cn(
                    {
                        'text-negative':
                            'waxbuyoffers' !== market ? diff > 0 : diff < 0,
                    },
                    {
                        'text-positive':
                            'waxbuyoffers' !== market ? diff <= 0 : diff > 0,
                    },
                )}
            >
                &nbsp;
                {` (${diff > 0 ? '+' : ''}${formatWAX(diff)})`}
            </div>
        </Tooltip>
    )
}

export const formatDiff = (diff, market, target) => {
    return diff || diff === 0 ? (
        <Tooltip
            title={
                'waxbuyoffers' !== market
                    ? diff > 0
                        ? `Price is ${formatPercentageFull(
                              diff,
                          )} above ${target}`
                        : `Price is ${formatPercentageFull(
                              diff,
                          )} below ${target}`
                    : diff > 0
                    ? `Offer is ${formatPercentageFull(diff)} above ${target}`
                    : `Offer is ${formatPercentageFull(diff)} below ${target}`
            }
        >
            <div
                className={cn(
                    {
                        'text-negative':
                            'waxbuyoffers' !== market ? diff > 0 : diff < 0,
                    },
                    {
                        'text-positive':
                            'waxbuyoffers' !== market ? diff < 0 : diff > 0,
                    },
                )}
            >
                &nbsp;
                {diff || diff === 0
                    ? ` (${diff > 0 ? '+' : ''}${formatPercentage(diff)})`
                    : ''}
            </div>
        </Tooltip>
    ) : (
        ''
    )
}

export const getViewer = async (model, poster) => {
    let viewer = ''
    if (typeof window !== 'undefined')
        viewer = await import('@google/model-viewer').then(() => {
            const src = model.replace('ipfs.hivebp.io', 'ipfs.io')
            const element = (
                <div className={'w-100 h-100'}>
                    <model-viewer
                        className={cn(
                            'm-auto max-h-64 md:max-h-[70vh] md:py-[2.5vh] max-w-full',
                        )}
                        src={src}
                        camera-controls
                        poster={poster}
                        autoplay
                        shadow-intensity="1"
                        touch-action="pan-y"
                    />
                </div>
            )

            return element
        })

    return viewer
}

export const getSellingElement = (str) => {
    const parts = str.split('|')
    return (
        <div>
            {parts[0]}
            <b>{parts[1]}</b>
            {parts[2]}
            <b>{parts[3]}</b>
        </div>
    )
}

export const formatNumber = (value) => {
    const number = parseInt(value)
    if (Math.abs(number) >= 1000000000)
        return `${parseInt(`${Math.round(number / 10000000.0)}`) / 10.0}B`
    else if (Math.abs(number) >= 1000000)
        return `${parseInt(`${Math.round(number / 100000.0)}`) / 10.0}M`
    else if (Math.abs(number) >= 10000)
        return `${parseInt(`${Math.round(number / 100.0)}`) / 10.0}K`
    else return Math.round(value * 100) / 100
}

export const copyTextToClipboard = (text) => {
    if (!navigator.clipboard) {
        return
    }
    navigator.clipboard.writeText(text).then(
        function () {
            console.error('Async: Copying to clipboard was successful!')
        },
        function (err) {
            console.error('Async: Could not copy text: ', err)
        },
    )
}

export const formatRAM = (value) => {
    const number = parseInt(value)
    if (Math.abs(number) >= 1024 * 1024 * 1024)
        return `${
            parseInt(
                `${Math.round((number / (1024.0 * 1024.0 * 1024.0)) * 10)}`,
            ) / 10.0
        }GB`
    else if (Math.abs(number) >= 1024 * 1024)
        return `${
            parseInt(`${Math.round((number / (1024.0 * 1024.0)) * 10)}`) / 10.0
        }MB`
    else if (Math.abs(number) >= 1024)
        return `${parseInt(`${Math.round((number / 1024.0) * 10)}`) / 10.0}KB`
    else return `${Math.round(number * 100) / 100} Byte`
}

export const formatRateNumber = (value) => {
    const number = parseInt(value)
    if (Math.abs(number) >= 1000000000)
        return `${Math.round(
            parseInt(`${Math.round(number / 10000000.0)}`) / 10.0,
        )}B`
    else if (Math.abs(number) >= 1000000)
        return `${Math.round(
            parseInt(`${Math.round(number / 100000.0)}`) / 10.0,
        )}M`
    else if (Math.abs(number) >= 10000)
        return `${Math.round(
            parseInt(`${Math.round(number / 100.0)}`) / 10.0,
        )}K`
    else if (Math.abs(number) >= 100)
        return parseInt(`${Math.round(value * 100) / 100}`)
    else return Math.round(value * 100) / 100
}

export const validJson = (str) => {
    try {
        JSON.parse(str)
    } catch (e) {
        return false
    }
    return true
}

export const formatUSD = (usd) => {
    return usd || usd === 0
        ? `$${usd.toLocaleString(undefined, {
              maximumFractionDigits: 2,
              minimumFractionDigits: 2,
          })}`
        : ''
}

export const formatUSD2 = (usd) => {
    return usd || usd === 0
        ? `${usd.toLocaleString(undefined, {
              maximumFractionDigits: 2,
              minimumFractionDigits: 2,
          })} USD`
        : ''
}

export const rgbToHex = (r, g, b) => {
    return (
        '#' +
        [r, g, b, 128]
            .map((x) => {
                const hex = x.toString(16)
                return hex.length === 1 ? '0' + hex : hex
            })
            .join('')
            .toUpperCase()
    )
}

export const formatWAX = (wax) => {
    return wax || wax === 0
        ? `${wax.toLocaleString(undefined, {
              maximumFractionDigits: 8,
              minimumFractionDigits: 0,
          })} WAX`
        : ''
}

export const formatWAXS = (wax) => {
    return wax || wax === 0
        ? `${wax.toLocaleString(undefined, {
              maximumFractionDigits: 2,
              minimumFractionDigits: 0,
          })} WAX`
        : ''
}

export const formatWAXInt = (wax) => {
    return wax || wax === 0
        ? `${wax.toLocaleString(undefined, {
              maximumFractionDigits: 0,
              minimumFractionDigits: 0,
          })} WAX`
        : ''
}

export const formatCurrency = (currency, decimals, useGrouping, symbol) => {
    return (
        currency.toLocaleString(undefined, {
            maximumFractionDigits: decimals,
            minimumFractionDigits: decimals,
            useGrouping: useGrouping,
        }) +
        ' ' +
        symbol
    )
}

export const formatAssetData = (data) => {
    if (!data) return null
    const assetData = {}

    if (typeof data === 'object') {
        return data
    }

    for (const item of data) {
        if (item?.value && item?.key) {
            assetData[item.key] = item.value[1]
        }
    }

    return assetData
}

export const extractAssetData = (asset) => {
    const { mutableData, immutableData, template } = asset

    const mData =
        mutableData && mutableData.length > 0
            ? formatAssetData(mutableData)
            : null
    const iData =
        immutableData && immutableData.length > 0
            ? formatAssetData(immutableData)
            : null
    const tData =
        template?.immutableData && template?.immutableData.length > 0
            ? formatAssetData(template?.immutableData)
            : null

    return { mData, iData, tData }
}

export const formatHoney = (honey) => {
    return `${honey.toLocaleString(undefined, {
        maximumFractionDigits: 4,
        minimumFractionDigits: 4,
    })} HONEY`
}

export const formatToken = (amount, token, digits) => {
    return `${amount.toLocaleString(undefined, {
        maximumFractionDigits: digits,
        minimumFractionDigits: digits,
    })} ${token}`
}

export const formatUSDM = (value) => {
    const number = parseInt(value)
    if (Math.abs(number) >= 1000000000)
        return `$${parseInt(`${Math.round(number / 10000000.0)}`) / 10.0}B`
    else if (Math.abs(number) >= 1000000)
        return `$${parseInt(`${Math.round(number / 100000.0)}`) / 10.0}M`
    else if (Math.abs(number) >= 10000)
        return `$${parseInt(`${Math.round(number / 100.0)}`) / 10.0}K`
    else
        return `$${number.toLocaleString(undefined, {
            maximumFractionDigits: 2,
            minimumFractionDigits: 2,
        })}`
}

export const formatDate = (timestamp) => {
    const utc = moment.utc(timestamp).toDate()
    return moment(utc).local().format('YYYY-MM-DD HH:mm:ss')
}

export const formatNumberS = (value) => {
    return Math.round(value * 10000) / 10000.0
}

export const formatNumber1K = (value) => {
    const number = parseInt(value)
    if (Math.abs(number) >= 1000000000)
        return `${parseInt(`${Math.round(number / 10000000.0)}`) / 10.0}B`
    else if (Math.abs(number) >= 1000000)
        return `${parseInt(`${Math.round(number / 100000.0)}`) / 10.0}M`
    else if (Math.abs(number) >= 1000)
        return `${parseInt(`${Math.round(number / 100.0)}`) / 10.0}K`
    else if (Math.abs(number) >= 10) return Math.round(value)
    else return value
}

export const formatPercentage = (value) => {
    const number = Math.round(parseFloat(value) * 10000.0) / 100.0
    return `${formatNumber1K(number)}%`
}

export const formatPercentageFull = (value) => {
    const number = Math.round(parseFloat(value) * 10000.0) / 100.0
    return `${formatNumber(number)}%`
}

export const formatTransaction = (tx) => {
    return tx.substring(0, 20) + '…'
}

export const formatGrowth = (value, usd = 0, includeWAX = false) => {
    const number = parseInt(value)
    if (number > 0)
        return (
            <div className="flex items-center">
                <svg
                    className="fill-primary"
                    width="16"
                    height="16"
                    viewBox="0 0 16 16"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path d="M9 7v6H7V7H4l4-4 4 4z" fillRule="evenodd"></path>
                </svg>
                <div>
                    {includeWAX
                        ? `${formatNumber(value)} WAX`
                        : formatNumber(value)}
                    {usd ? (
                        <span className="text-xs">/${formatNumber(usd)}</span>
                    ) : null}
                </div>
            </div>
        )
    if (number < 1000000)
        return (
            <div className="flex items-center">
                <svg
                    className="fill-neutral"
                    width="16"
                    height="16"
                    viewBox="0 0 16 16"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path d="M9 9h3l-4 4-4-4h3V3h2z" fillRule="evenodd"></path>
                </svg>
                <div>
                    {includeWAX
                        ? `${formatNumber(value)} WAX`
                        : formatNumber(value)}
                    {usd ? (
                        <span className="text-xs">/${formatNumber(usd)}</span>
                    ) : null}
                </div>
            </div>
        )
    else return '-'
}

export const formatMarket = (market) => {
    return market
}
